import { z } from "zod";

//DiarioObrasParalisacoesSchema

// Helpers
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const DiarioObrasImagensSchema = z.object({
  IdDiarioObrasImagens: z.number().int().default(0),
  IdDiarioObras: optionalNumber,
  DescricaoImagem: optionalString.pipe(z.string().max(250, "Máximo de 250 caracteres").nullable().optional()),
  ExtensaoImagem: optionalString.pipe(z.string().max(50, "Máximo de 50 caracteres").nullable().optional()),
  Nome: optionalString.pipe(z.string().max(100, "Máximo de 100 caracteres").nullable().optional()),
  Ordem: optionalNumber,
});

export type DiarioObrasImagensForm = z.infer<typeof DiarioObrasImagensSchema>;